export const SUPPORT = [
  {
    name: "Free Agent Tutorial",
    link: "https://youtube.com/shorts/_wbXLa3lc9E?feature=share",
  },
  {
    name: "Line Up Tutorial",
    link: "https://youtube.com/shorts/GpReNkD2Oys?feature=share",
  },
  {
    name: "Reschedule Tutorial",
    link: "https://youtube.com/shorts/4frz_8QFIPE?feature=share",
  },
  {
    name: "Player Stats Tutorial",
    link: "https://youtube.com/shorts/Wpoy0mkqLeI?feature=share",
  },
  {
    name: "How to Sign up to a league",
    link: "https://youtube.com/shorts/1Wfb9QY96dk?feature=share",
  },
  {
    name: "Sign players Tutorial",
    link: "https://youtube.com/shorts/oSmcYpuus4I?feature=share",
  },
  {
    name: "Social feed Tutorial",
    link: "https://youtube.com/shorts/TbtEy91lDF4?feature=share",
  },
  {
    name: "Submit score Tutorial",
    link: "https://youtube.com/shorts/fFgpmb11zeA?feature=share",
  },
  {
    name: "Team recruitment Tutorial",
    link: "https://youtube.com/shorts/uCxe9_kgk8M?feature=share",
  },
  {
    name: "Transfer Tutorial",
    link: "https://youtube.com/shorts/u5IyZDmsprI?feature=share",
  },
  {
    name: "Easy Communication",
    link: "https://youtube.com/shorts/K6UO74Ut6mc?feature=share",
  },
  {
    name: "Team Chat system",
    link: "https://youtu.be/WjcrQxJAfgw",
  },
  {
    name: "Notifications Tutorial",
    link: "https://youtube.com/shorts/XUYa9P9LJT4?feature=share",
  },
  {
    name: "Star System",
    link: "https://youtube.com/shorts/INIg9u2a1G0?feature=share",
  },
  {
    name: "Icon System",
    link: "https://youtube.com/shorts/WdbIvX-GWng?feature=share",
  },
  {
    name: "World Rankings",
    link: "https://youtube.com/shorts/OOVV7pKKTks?feature=share",
  },
];
